export const Icons = {
  BOARD: 'dashboard',
  DASHBOARD: 'new-grid-item',
  SAVED_VIEW: 'grouped-bar-chart'
};
